<template lang="pug">
el-dialog(title="Authenticate" :visible="authVisible" :show-close="false" width="30%")
  span.dialog-footer(slot="footer")
    el-button(@click="hideDialog()") Cancel
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SiteAuth",
  computed: {
    ...mapGetters(["authVisible"])
  },
  methods: {
    hideDialog() {
      this.$store.dispatch("setAuthVisible", false);
    }
  }
};
</script>

<style lang="stylus" scoped></style>
